import { styled } from '@mui/material';

export const OuterContainer = styled('div')({
  position: 'relative',
});

export const Container = styled('div')({
  borderRadius: '8px',
  height: 0,
  overflow: 'hidden',
  paddingBottom: '150%',
});

export const Image = styled('img')(({ theme }) => ({
  border: '1px solid',
  borderRadius: theme.spacing(1),
  display: 'block',
  objectPosition: 'center',
  width: '100%',
}));

export const CertificationIconContainer = styled('div')(({ theme }) => ({
  bottom: theme.spacing(1),
  display: 'flex',
  position: 'absolute',
  right: theme.spacing(1),
}));
